function touchLinkAcess() {
  // Variable is true on touch devices.
  const touchDevice = 'ontouchstart' in window || !!(navigator.msMaxTouchPoints)
  if (touchDevice) {
    // Target each menu item which has a dropdown menu.
    $(".selection").each(function (index) {
      // Grab the hyperlink we want to duplicate
      const hyperlink = $(this).parent().children(":first")
      // Prepend it to the beginning of the dropdown menu.
      $(this).prepend("<li class=\"selection-item\"><a href=\"" + hyperlink.attr('href') + "\">" + hyperlink.text() +  "</a></li>")
      $(this).parent().children(":first").bind('click', false)
    })
  }
}

$(document).ready(touchLinkAcess)
$(window).resize(touchLinkAcess)



// WEBPACK FOOTER //
// ./src/browser/oldJs/lib/touch-device-menu.js